<mat-toolbar color="primary" class="item-panel-toolbar">
    <span>Codes</span>
    <span class="toolbar-spacer"></span>
    <mat-form-field class="panel-header-search" appearance="legacy">
      <input type="text" [disabled]="isSearching" matInput #searchInput>
      <fa-icon matSuffix [icon]="['fas','search']"></fa-icon>
    </mat-form-field>
</mat-toolbar>
<mat-toolbar *ngIf="userConfig.profileValue('CNConsultation','displaycontacttype')" color="primary" class="item-panel-toolbar">
  <app-contact-types-group-list (selected)="selectType($event)" class="field-full-width"></app-contact-types-group-list>
</mat-toolbar>
<mat-accordion class="menu-headers-align" multi>
    <mat-expansion-panel *ngFor="let group of groups" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ group.value }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-service-code-group [group]="group" (action)="codeAction($event)"></app-service-code-group>
    </mat-expansion-panel>
</mat-accordion>